    class PlugMobileMenu extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.elements = {
            header: this.closest("plug-header"),
            headerSection: this.closest(".plug-header-section"),
            l1Buttons: Array.from(this.getElementsByClassName("plug-mobile-menu__l1-link")),
            l2Buttons: Array.from(this.getElementsByClassName("plug-mobile-menu__l2-link")),
            menuButton: document.querySelector(".plug-header__icon-item--menu .plug-header__icon-button"),
            overlay: this.querySelector(".plug-mobile-menu__overlay"),
            submenuBackButtons: Array.from(this.getElementsByClassName("plug-mobile-menu__back-button")),
        };

        this.initListeners();
    }

    initListeners() {
        this.elements.overlay.addEventListener("click", (e) => {
            this.close();
        });

        this.elements.menuButton.addEventListener("click", (e) => {
            const isOpen = this.elements.menuButton.classList.contains("is-active");
            if (isOpen) {
                this.close();
            } else {
                this.open();
            }
        });

        this.elements.l1Buttons.forEach(l1Button => {
            const submenu = document.getElementById(l1Button.dataset.submenuId);
            if (submenu) {
                l1Button.addEventListener("click", () => {
                    l1Button.setAttribute("aria-expanded", "true");
                    this.openSubmenu(submenu);
                });
            }
        });

        this.elements.submenuBackButtons.forEach(backButton => {
            const submenu = backButton.closest(".plug-mobile-menu__submenu");
            const l1Button = this.elements.l1Buttons.find(button => button.dataset.submenuId === submenu.id);
            backButton.addEventListener("click", (e) => {
                if (l1Button) {
                    l1Button.setAttribute("aria-expanded", "false");
                }
                this.closeSubmenu(submenu);
            });
        });

        this.elements.l2Buttons.forEach(l2Button => {
            l2Button.addEventListener("click", (e) => {
                const l2 = l2Button.closest(".plug-mobile-menu__l2");
                const l3List = l2.querySelector(".plug-mobile-menu__l3-list");
                if (!l2.classList.contains("is-open")) {
                    l3List.classList.remove("is-hidden");
                    requestAnimationFrame(() => {
                        setTimeout(() => {
                            l2.classList.add("is-open");
                        }, 0);
                    });
                } else {
                    l3List.classList.add("is-hidden");
                    l2.classList.remove("is-open");
                }
            });
        });

        this.initResizeListener();

        this.addEventListener("keydown", (e) => {
            if (e.key === "ArrowDown" || e.key === "ArrowUp" || e.key === "Tab") {
                e.preventDefault();
                const activeElement = document.activeElement;
                const activeMenu = (
                    activeElement.closest(".plug-mobile-menu__submenu")
                    ? activeElement.closest(".plug-mobile-menu__submenu")
                    : this.querySelector(".plug-mobile-menu__main-menu")
                );
                const focusableElements = Array.from(
                    activeMenu.querySelectorAll("a, button")
                ).filter(el => !el.closest(".is-hidden"));
                const index = focusableElements.indexOf(activeElement);
                if (index >= 0) {
                    if (e.key === "ArrowDown" || (e.key === "Tab" && !e.shiftKey)) {
                        if (index < focusableElements.length - 1) {
                            focusableElements[index + 1].focus();
                        } else {
                            focusableElements[0].focus(); // Loop to first element
                        }
                    } else {
                        if (index > 0) {
                            focusableElements[index - 1].focus();
                        } else {
                            focusableElements[focusableElements.length - 1].focus(); // Loop to first element
                        }
                    }
                }
            } else if (e.key === "Escape") {
                e.preventDefault();
                const activeSubmenu = this.querySelector(".plug-mobile-menu__submenu.is-open");
                if (activeSubmenu) {
                    this.closeSubmenu(activeSubmenu);
                }
                this.close();
            }
        });
    }

    initResizeListener() {
        let resizeTimeout = undefined;
        const handleResize = () => {
            this.style.top = `${this.elements.header.getBoundingClientRect().bottom}px`;
            if (!this.isMobile()) {
                this.close();
            }
        };

        window.addEventListener("resize", () => {
            if (this.elements.menuButton.classList.contains("is-active")) {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => {
                    handleResize();
                }, 200);
            }
        });
    }

    open() {
        this.style.top = `${this.elements.header.getBoundingClientRect().bottom}px`;
        document.body.classList.add("plug-no-scroll");
        this.elements.menuButton.classList.add("is-active");
        this.classList.remove("is-hidden");
        this.elements.headerSection.classList.add("plug-force-bg");
        requestAnimationFrame(() => {
            setTimeout(() => {
                this.classList.add("is-open");
            }, 0);
        });
        const smileUiContainer = document.querySelector("#smile-ui-container");
        if (smileUiContainer) {
            smileUiContainer.classList.add("is-hidden");
        }
    }

    close() {
        this.elements.menuButton.classList.remove("is-active");
        this.classList.remove("is-open");
        document.body.classList.remove("plug-no-scroll");
        setTimeout(() => {
            this.classList.add("is-hidden");
            const smileUiContainer = document.querySelector("#smile-ui-container");
            if (smileUiContainer) {
                smileUiContainer.classList.remove("is-hidden");
            }
            this.elements.headerSection.classList.remove("plug-force-bg");
        }, 150);
    }

    openSubmenu(submenu) {
        submenu.classList.remove("is-hidden");
        const links = submenu.querySelectorAll("a, button");
        requestAnimationFrame(() => {
            setTimeout(() => {
                submenu.classList.add("is-open");
                setTimeout(() => {
                    if (links[0]) {
                        links[0].focus(); // Focus the first link in the submenu
                    }
                }, 300);
            }, 0);
        });
    }

    closeSubmenu(submenu) {
        submenu.classList.remove("is-open");
        const l1Button = this.elements.l1Buttons.find(button => button.dataset.submenuId === submenu.id);
        if (l1Button) {
            l1Button.focus(); // Return focus to the L1 button that opened the submenu
        }
        setTimeout(() => {
            submenu.classList.add("is-hidden");
        }, 150);
    }

    isMobile() {
        return window.innerWidth < 1200;
    }
}

if (!customElements.get("plug-mobile-menu")) {
    customElements.define("plug-mobile-menu", PlugMobileMenu);
}